import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import Index from './index';
import CastleActivitySearch from './castleActivitySearch/castleActivitySearchRoute';
import { DataProvider } from '../assignments/DataContext';
import PersonalContentSet from './personalContentSearch/personalContentSet';
import { ActivitySearchProvider } from './context';
import PersonalContentSetVocabularies from './personalContentSearch/pcsVocabularies';

const Main = () => {
  return (
    <div>
      <ActivitySearchProvider>
        <Routes>
          <Route path="/" element={<DataProvider><Index /></DataProvider>}>
            <Route index element={<Navigate to="activities/castle_activities" />} />
            <Route path="activities/:activityId?/castle_activities/*" element={<CastleActivitySearch />} />
            <Route path=":activityId?/personal_content_sets/*" element={<PersonalContentSet />} />
            <Route path=":activityId?/personal_content_sets/pcsVocabularies" element={<PersonalContentSetVocabularies />} />
          </Route>
        </Routes>
      </ActivitySearchProvider>
    </div>
  );
};

export default Main;